import { Check, FileClock, House } from 'lucide-react';

import type { PatientSignature } from './patientSignatureLabel';

/**
 * The glyph for one patient-signature state. Decorative: callers carry the
 * accessible name, usually from `patientSignatureLabel`.
 *
 * Signed, unable-to-sign and missing are one house with a different corner
 * badge. `previous_emr` is deliberately not a house. The house means "Roger's
 * record of this visit's signature", and Roger holds none here, so a bare
 * house would read as missing. The dated-file mark says the record is elsewhere,
 * from before, with no claim either way.
 */
export function PatientSignatureIcon({
  state,
  className,
}: {
  state: PatientSignature | null | undefined;
  className?: string;
}) {
  if (state === 'previous_emr') {
    return (
      <span
        className={`relative inline-flex shrink-0 ${className ?? ''}`}
        aria-hidden='true'
        data-signature-state='previous_emr'
      >
        <FileClock className='h-4 w-4 text-muted-foreground' />
      </span>
    );
  }
  return (
    <span
      className={`relative inline-flex shrink-0 ${className ?? ''}`}
      aria-hidden='true'
      data-signature-state={state ?? 'missing'}
    >
      <House className='h-4 w-4 text-muted-foreground' />
      {state === 'signed' && (
        <span className='absolute -bottom-0.5 -right-0.5 inline-flex h-2.5 w-2.5 items-center justify-center rounded-full bg-emerald-600'>
          <Check strokeWidth={4} className='h-1.5 w-1.5 text-white' />
        </span>
      )}
      {state === 'unable_to_sign' && (
        <span className='absolute -bottom-0.5 -right-0.5 inline-flex h-2.5 w-2.5 items-center justify-center rounded-full bg-amber-500'>
          <span className='text-[7px] font-bold leading-none text-white'>
            !
          </span>
        </span>
      )}
    </span>
  );
}
